function BlogMain() {
    return ( 
        <>
            <section className="blog-main">
                <div className="container">
                    <div className="heading">Our blog</div>
                    <div className="description">
                        Dive into a world of engaging stories, helpful tips, and insider insights tailored for OnlyFans creators and enthusiasts. Discover inspiring user success stories, step-by-step guides to grow your profile, and the latest trends shaping the platform.
                    </div>
                </div>
            </section>
        </>
     );
}

export default BlogMain;